import { reduce } from 'lodash/fp'

export const composeReducers =
  (...args) =>
  (state, action) =>
    reduce((previousState, fn) => fn(previousState, action), state, args)

export default composeReducers
